import axios, { AxiosInstance } from 'axios';
import { environment } from '../config/environment';

export const createApiClient = (token?: string): AxiosInstance => {
    const client = axios.create({
        timeout: 0,
        withCredentials: true, // Enable sending cookies with requests
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    });

    if (environment.useMockApi) {
        // Add a response interceptor for mock mode
        client.interceptors.response.use(async (config) => {
            // Add a small delay to simulate network latency in mock mode
            await new Promise((resolve) => setTimeout(resolve, 500));
            return config;
        });
    }

    return client;
};
